<template>
    <nav :class="mobileShowMenuClass">
        <div v-if="role == 1" class="nav-switcher">
            <app-select
                v-model="school"
                placeholder="Switch School">
                <app-option
                    v-for="item in schools"
                    :key="item.id"
                    :label="item.name"
                    :value="item.id"/>
            </app-select>
        </div>
        <div class="vertical-align">
            <router-link :to="{ name: 'home' }">
                <span class="icon icon-dashboard" alt="Dashboard"/>
                <span class="text">Dashboard</span>
            </router-link>
            <router-link :to="{ name: 'students' }">
                <span class="icon icon-students" aria-hidden="true"/>
                <span class="text">Students</span>
            </router-link>
            <router-link :to="{ name: 'courses' }">
                <span class="icon icon-courses" aria-hidden="true"/>
                <span class="text">Courses</span>
            </router-link>
            <router-link :to="{ name: 'events' }">
                <span class="icon icon-events" aria-hidden="true"/>
                <span class="text">Events</span>
            </router-link>
            <router-link :to="{ name: 'teams' }">
                <span class="icon icon-teams" aria-hidden="true"/>
                <span class="text">Teams</span>
            </router-link>
            <router-link :to="{ name: 'reports' }">
                <span class="icon icon-reports" aria-hidden="true"/>
                <span class="text">Reports</span>
            </router-link>
            <router-link
                v-if="$role.isAdmin() || $role.isAdvisor() || $role.isCoach() || $role.isProfessor()"
                :to="{ name: 'users' }">
                <span class="icon icon-users" aria-hidden="true"/>
                <span class="text">Users</span>
            </router-link>
        </div>

        <router-link v-if="$role.isAdmin()" :to="{ name: 'settings.school' }" class="bottom-fixed">
            <span class="icon icon-settings" aria-hidden="true"/>
            <span class="text">Settings</span>
        </router-link>
    </nav>
</template>

<script>
import { mapGetters, mapState, mapActions } from 'vuex'
import { isMobileScreenSize, get } from '../../utilities'

export default {
    name: 'sidebar',
    components: {},
    computed: {
        ...mapState({
            current: ({ me }) => me.current,
            showMenu: ({ params }) => params.showMenu,
            schools: ({ params }) => params.schools
        }),
        ...mapGetters(['role']),
        mobileShowMenuClass() {
            return this.showMenu ? 'mobile-show-menu' : ''
        },
        school: {
            get() {
                return get(this, 'current.schoolId')
            },
            set(val) {
                this.switchSchool({ schoolId: val }).then(() => {
                    this.$router.push({ name: 'home' })
                    location.reload()
                })
            }
        }
    },
    methods: {
        ...mapActions(['switchSchool'])
    },
    watch: {
        $route: function() {
            if (isMobileScreenSize()) {
                this.$store.commit('HIDE_MENU')
            }
        }
    }
}
</script>

<style lang="stylus">
@import '../../stylus/variables'

nav
    position: fixed
    top: 0px
    left: 0px
    width: 80px
    height: 100%
    background: $dark-grey
    padding-top: 80px
    align-items: center
    justify-content: center
    display: flex
    flex-direction: column
    padding-bottom: 80px

    @media screen and (max-height: 640px)
        padding-bottom: 0px
        display: block
        justify-content: inherit

    .nav-switcher
        display: none
        margin: 0px 10px

    .vertical-align
        width: 100%

    a
        display: block
        color: #969faa
        font-size: 11px
        font-weight: 500
        letter-spacing: 0.5px
        text-decoration: none
        text-align: center
        min-height: 70px
        display: flex
        align-items: center
        justify-content: center
        flex-direction: column
        border-left: 3px solid transparent
        padding-right: 3px
        position: relative

        span
            display: block

            &.text
                position: absolute
                bottom: 4px
                transition: opacity 0.25s, bottom 0.25s
                border: 0
                opacity: 0
                clip: rect(0 0 0 0)
                height: 1px
                width: 1px
                margin: -1px
                overflow: hidden
                padding: 0
                position: absolute

                @media screen and (max-width: 480px)
                    bottom: 12px
                    height: auto
                    width: auto
                    opacity: 1
                    margin: inherit
                    clip: auto
                    overflow: auto

            &.icon
                font-size: 28px
                width: 100%
                transition: margin-top 0.25s

        &.router-link-active, &:hover, &:focus
            background: $darker-grey
            border-left: 3px solid $medium-blue

            span.icon
                margin-top: -8px

            span.text
                bottom: 12px
                height: auto
                width: auto
                opacity: 1
                margin: inherit
                clip: auto
                overflow: auto

        &.router-link-active, &:focus
            color: #FFF

        &.bottom-fixed
            position: absolute
            width: 100%
            bottom: 0px

            @media screen and (max-height: 640px)
                position: relative
                bottom: auto

    @media screen and (max-width: 1024px)
        width: 70px
        padding-top: 70px

        a
            max-height: 70px

    @media screen and (max-width: 480px)
        width: 160px
        z-index: 100
        display: block
        right: -160px
        left: auto
        padding-top: 10px
        transition: transform 0.25s

        &.mobile-show-menu
            transform: translate(-160px, 0px)

        .nav-switcher
            display: block

        a
            flex-direction: row
            align-items: center
            justify-content: left
            text-align: left
            min-height: 60px

            span
                &.text
                    position: relative
                    opacity: 1
                    transition: all 0.25s
                    bottom: 2px

                &.icon
                    width: 50px
                    flex-grow: 0
                    text-align: right
                    padding-right: 10px

            &.router-link-active, &:hover, &:focus
                background: $darker-grey
                border-left: 3px solid $medium-blue

                span.icon
                    margin-top: 0px

                span.text
                    bottom: 2px
                    opacity: 1
</style>
